// Copyright (c) 2021 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import document from "global/document";
import jwt from "jsonwebtoken";
import React, { useState } from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { browserHistory, Route, Router } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import { default as localStorage } from "../node_modules/store";
import App from "./app";
import store from "./store";
import { buildAppRoutes } from "./utils/routes";

const history = syncHistoryWithStore(browserHistory, store);

const appRoute = buildAppRoutes(App);

const Root = () => {
  const [token, setToken] = useState(localStorage.get("jwt"));
  let autoLogIn = false;
  // const [token, setToken] = useState("asdfas");
  function loginUser(pwd) {
    let newToken;
    if (pwd === "stackbox321") {
      newToken = jwt.sign({ valid: true }, "secret", { expiresIn: "1d" });
      localStorage.set("mode", "view");
      store.dispatch({
        type: 'CHANGE_MODE',
        mode: 'view',
      });
    } else if (pwd === "stackbox321internal") {
      newToken = jwt.sign({ valid: true }, "secret", { expiresIn: "30d" });
      localStorage.set("mode", "save");
      store.dispatch({
        type: 'CHANGE_MODE',
        mode: 'save',
      });
    } else if (pwd === "manish123") {
      newToken = jwt.sign({ valid: true }, "secret", { expiresIn: "3d" });
    }
    
    localStorage.set("jwt", newToken);

    setToken(newToken);
  }

  let validToken = false;
  try {
    validToken = jwt.verify(token, "secret").valid;
  } catch (err) {
    console.log(err);
  }


  const queryParams = new URLSearchParams(window.location.search);
  autoLogIn = (queryParams.get("autoLogin")==='true');
  try {
    if(autoLogIn==true){
      validToken = true;
      store.dispatch({
        type: 'CHANGE_MODE',
        mode: 'save',
      });
    }
  } catch(e) {
      console.log(e)
  }

  const pathname = window.location.pathname;
  if (pathname.indexOf('/view')!=-1){
    validToken = true;
      store.dispatch({
        type: 'CHANGE_MODE',
        mode: 'view',
      });
  }


  return !validToken ? (
    <LoginForm login={loginUser} />
  ) : (
    <Provider store={store}>
      <Router history={history}>
        <Route path="/" component={App}>
          {appRoute}
        </Route>
      </Router>
    </Provider>
  );
};
const LoginForm = ({ login }) => {
  const [password, setPassword] = useState("");

  function keyPress(e) {
    if (e.keyCode == 13) {
      login(password);
    }
  }

  return (
    <div style={{ textAlign: "center", fontSize: "24px" }}>
      <p>Password</p>
      <input
        type="password"
        name="Password"
        autoFocus
        style={{ fontSize: "24px", textAlign: "center" }}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={keyPress}
      ></input>
    </div>
  );
};
render(<Root />, document.body.appendChild(document.createElement("div")));
